import config from 'config';
import rewardStore from 'modules/cms/stores/reward';
import { LOADING, LOADED } from 'stores/BaseStore';
import appStore from 'stores/app';
import HttpClient from 'utils/httpclient';

import { buildEntity } from './base-store';

export default new class RewardsReportStore {
  data = {};
  status = LOADED;

  async getRewards(params) {
    try {
      this.status = LOADING
      params.siteId = appStore.site.id
      const { data: { completions: data } } = await HttpClient.get(`${config.api}/reports/rewards`, { params })
      this.data = data
      this.status = LOADED
      return data
    } catch (e) {
      this.status = LOADED
      return null
    }
  }

  async markAsPaid(completionId) {
    try {
      this.status = LOADING
      await HttpClient.put(`${config.api}/reward-completition/${completionId}/paid`)
      this.status = LOADED
      return true
    } catch (e) {
      this.status = LOADED
      return false
    }
  }
  reward = buildEntity(rewardStore, {
    params: { siteId: appStore?.site?.id },
  })

  get isLoading() {
    return this.status === LOADING
  }
}
